import { InvoiceStatus } from '@acceligentllc/shared/enums/invoiceStatus';

enum InvoiceStatusDisplay {
	DRAFT = 'DRAFT', // what the invoice starts out with
	INVOICED = 'INVOICED', // it is invoiced and there are no installments added
	PARTIALLY_PAID = 'PARTIALLY PAID', // there are installments and total paid < total
	PAID = 'PAID', // there are installments and total paid = total
	OVERPAID = 'OVERPAID', // there are installments and total paid > total
}

export const resolveStatusForDisplay = (invoiceStatus: InvoiceStatus, totalAmount: number, paidByInstallments: number) => {
	if (paidByInstallments === 0) {
		if (invoiceStatus === InvoiceStatus.DRAFT) {
			return InvoiceStatusDisplay.DRAFT;
		}
		return InvoiceStatusDisplay.INVOICED;
	}

	if (paidByInstallments < totalAmount) {
		return InvoiceStatusDisplay.PARTIALLY_PAID;
	} else if (paidByInstallments === totalAmount) {
		return InvoiceStatusDisplay.PAID;
	} else {
		return InvoiceStatusDisplay.OVERPAID;
	}
};

export default InvoiceStatusDisplay;
